
<div class="deviceNum" *ngIf="devices">
  <h1>{{devices.length}}</h1>
  <p *ngIf="_sharedVar.devicesArray.length == 1">
    appareil en activité
  </p>
  <p *ngIf="_sharedVar.devicesArray.length > 1">
    appareils en activité
  </p>
</div>

<mat-chip-listbox aria-label="device selection" *ngIf="devices">

  <mat-chip-option (click)="changeSelectedDevice(device.deviceName)" *ngFor="let device of devices">{{device.deviceName}}</mat-chip-option>


</mat-chip-listbox>
<mat-divider></mat-divider>

<div class="deviceStatus">
  <mat-card *ngFor="let device of devicesStatus" class="device">
    <div class="status">
      <div class="statusSymbol" [ngClass]="{'online': device.lastStatus == 'online', 'offline': device.lastStatus == 'offline'}">

      </div>
      <span class="statusText">{{device.lastStatus}}</span>
    </div>

    <div class="deviceId">
      <span>Id: {{device.deviceId}}</span>
    </div>
    <div class="deviceName">
      <h1>{{device.deviceName}}</h1>   <button mat-fab color="accent"  (click)="editBorneName(device)"> <mat-icon>edit</mat-icon></button>
    </div>
    <div class="printData">
      <span class="statusText">Impressions: </span>
      <span class="statusText">Total: {{device.printHistoryTotal || '0'}}</span>
      <span class="statusText">OK: {{device.printHistoryOk ||  '0'}}</span>
      <span class="statusText">Erreur: {{device.printHistoryNotOk || '0'}}</span>
    </div>
    <button class="histButton" mat-raised-button color="accent" (click)="showHistory(device)">Historique des connexions</button>
  </mat-card>
</div>
<mat-divider></mat-divider>

<h1><mat-icon>south</mat-icon>  Appareils les plus utilisés </h1>

<div class="dateRange">

  <mat-form-field>
    <mat-label>Période</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate [(ngModel)]="startDateRange">
      <input matEndDate [(ngModel)]="endDateRange">
    </mat-date-range-input>
    <mat-hint>JJ/MM/AAAA – JJ/MM/AAAA </mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker (closed)="setDateRange()"></mat-date-range-picker>
  </mat-form-field>

  <div (click)="resetDate()">
    <mat-icon>loop</mat-icon>
  </div>
</div>

<div class="chart" *ngIf="devices">

  <div class="loading" *ngIf="isLoading">

    <img src="assets/ui/loading.svg" />
  </div>

  <ngx-charts-bar-vertical [view]="view"
                           [scheme]="colorScheme"
                           [results]="devicesForCharts"
                           [gradient]="gradient"
                           [xAxis]="showXAxis"
                           [yAxis]="showYAxis"
                           [showXAxisLabel]="showXAxisLabel"
                           [showYAxisLabel]="showYAxisLabel"
                           [yAxisLabel]="yAxisLabel"
                           (select)="onSelect($event)">
  </ngx-charts-bar-vertical>
</div>

<!--<mat-divider></mat-divider>

<h1><mat-icon>south</mat-icon>  Languages les plus utilisés</h1>

<ngx-charts-pie-grid
  [view]="view"
  class="chart"
  [scheme]="colorScheme"
  [results]="langStats"
  (select)="onSelect($event)"
>
</ngx-charts-pie-grid>

<ngx-charts-pie-chart
  class="chart"
  [view]="view"
  [legend]="true"
  [scheme]="colorScheme"
  [results]="langStats"
  [gradient]="gradient"
  [legendPosition]="legendPosition"
  [labels]="showLabels"
  [doughnut]="isDoughnut"
  (select)="onSelect($event)"
  (activate)="onActivate($event)"
  (deactivate)="onDeactivate($event)"
>
</ngx-charts-pie-chart>-->
